<template>
  <div
    v-if="brands.length"
    class="ds-mb-8 ds-mt-7"
  >
    <div
      ref="wrapper"
      class="wrapper"
    >
      <AkHeading3>
        {{ eTitle }}
      </AkHeading3>
      <div class="featured-brands">
        <BrandSnippet
          v-for="brand in brands"
          :key="brand.id"
          :brand="brand"
        />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { getFeaturedBrands } from '@monolith/legacy/services/api/featured-brands';
import BrandSnippet from '@monolith/legacy/components/brand/brand-snippet-async.vue';

export default defineComponent({
  name: 'FeaturedBrands',
  components: {
    BrandSnippet,
  },
  props: {
    eTitle: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      brands: [],
    };
  },
  async mounted() {
    getFeaturedBrands().then((data) => (this.brands = data));
  },
});
</script>
<style scoped lang="scss">
.featured-brands {
  @apply ds-w-full ds-grid ds-grid-cols-2 md:ds-grid-cols-4 lg:ds-grid-cols-5 ds-gap-5 ds-p-0 ds-mt-6;
  grid-template-rows: auto auto;
}
</style>
